// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__9SRZ0","paramInput":"JobSimulator_paramInput__-STe4","input":"JobSimulator_input__1gTFq"};